// extracted by mini-css-extract-plugin
export default {"containerSwitcher":"LanguageSwitcherContainer_containerSwitcher__HCkte","boxExternalWithoutLogin":"LanguageSwitcherContainer_boxExternalWithoutLogin___ls0B"};